// 获取焦点,有些浏览器是不能自动聚焦的
export default {
  inserted(el) {
    el.focus();
  },
};
